import React from 'react'
import { Select } from 'antd'
import { InvoiceTemplate } from '../../../api/dto/invoice-delivery.dto'
import { INVOICE_TEMPLATE_LABELS } from './invoiceTemplates'
import styles from './TemplatePicker.module.scss'

const ALL_TEMPLATES = 'ALL'

interface TemplateFilterProps {
  value: InvoiceTemplate | undefined
  /** The templates the billing month allows. */
  templates: readonly InvoiceTemplate[]
  onChange: (template: InvoiceTemplate | undefined) => void
}

/** Table toolbar filter: show one email template, or all of them. */
const TemplateFilter: React.FC<TemplateFilterProps> = ({
  value,
  templates,
  onChange,
}) => (
  <Select<string>
    value={value ?? ALL_TEMPLATES}
    options={[
      { value: ALL_TEMPLATES, label: 'All templates' },
      ...templates.map((template) => ({
        value: template,
        label: INVOICE_TEMPLATE_LABELS[template],
      })),
    ]}
    onChange={(next) =>
      onChange(
        next === ALL_TEMPLATES
          ? undefined
          : templates.find((template) => template === next)
      )
    }
    aria-label="Filter by email template"
    className={styles.templateFilter}
  />
)

export { TemplateFilter }
